// extracted by mini-css-extract-plugin
export default {"root":"AppEmpty-module__root","img":"AppEmpty-module__img"};